module.exports = __webpack_public_path__ + "static/img/rule_title_bg.e4e03ca5.png";